/* Aden Salt Company — shared utilities. Loads first (gulp concatenates assets/js/scripts/ alphabetically).
   Ported from the original section-scripts-a.js outer IIFE: the header height CSS var, the "Get my price"
   buttons outside the hero, and the blur fade-in reveal system. The sticky header CTA and the header
   crossfade from that same IIFE live in 10-header.js; its supply-bento video and locations accordion
   sub-IIFEs belong to their section files. The "Hash deep links" IIFE below is from section-scripts-b.js,
   unchanged. */
(function(){
  "use strict";
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* ---------- Header height CSS var (used by the hero's header offset and the locations pin) ---------- */
  var headerEl = document.querySelector('.topbar');
  function setHeaderHeightVar(){
    if(headerEl){
      document.documentElement.style.setProperty('--header-h', headerEl.offsetHeight + 'px');
    }
  }
  setHeaderHeightVar();
  window.addEventListener('resize', setHeaderHeightVar);
  /* ---------- "Get my price" buttons outside the hero ----------
     The hero script owns the form: these buttons ask it to scroll into view and focus the ZIP field (or the
     current step once the flow has started). Product card buttons also preselect their salt. */
  function openHeroForm(salt){
    var ev;
    try{ ev = new CustomEvent('hvc:open', {detail:{salt:salt || ''}}); }
    catch(err){ ev = document.createEvent('CustomEvent'); ev.initCustomEvent('hvc:open', false, false, {salt:salt || ''}); }
    document.dispatchEvent(ev);
  }
  document.querySelectorAll('[data-scroll-target="hero"]').forEach(function(el){
    el.addEventListener('click', function(e){ e.preventDefault(); openHeroForm(''); });
  });
  document.querySelectorAll('.prod-card-cta').forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); openHeroForm(btn.getAttribute('data-salt')); });
  });
  /* ---------- Blur fade-in reveal system ---------- */
  var rvEls = document.querySelectorAll('.rv');
  if(reduceMotion || !('IntersectionObserver' in window)){
    rvEls.forEach(function(el){ el.classList.add('is-in'); });
  }else{
    var rvObserver = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          var el = entry.target;
          el.classList.add('is-in');
          obs.unobserve(el);
        }
      });
    }, {threshold:0.2});
    rvEls.forEach(function(el){ rvObserver.observe(el); });
  }
})();
/* ---------- Hash deep links (ads, emails) ---------- */
(function(){
  /* A cold load at #faq or #onepass lands before fonts, the forms and the pinned locations have
     settled, so the heading can end up under the sticky header. Land once more after load and
     fonts; section scroll-margin-top puts the target 16px below the header. A reader who has
     already started scrolling is left alone. */
  var hash = window.location.hash;
  if(!hash || hash.length < 2) return;
  var target = null;
  try{ target = document.getElementById(decodeURIComponent(hash.slice(1))); }catch(e){ target = null; }
  if(!target) return;
  var cancelled = false;
  function cancel(){ cancelled = true; }
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function(t){
    window.addEventListener(t, cancel, {passive:true, once:true});
  });
  function land(){
    if(cancelled) return;
    var root = document.documentElement;
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    target.scrollIntoView({block:'start'});
    root.style.scrollBehavior = prev;
  }
  function settle(){
    var fonts = (document.fonts && document.fonts.ready) ? document.fonts.ready : null;
    var go = function(){ window.requestAnimationFrame(function(){ window.requestAnimationFrame(land); }); };
    if(fonts && fonts.then){ fonts.then(go, go); } else { go(); }
  }
  if(document.readyState === 'complete') settle();
  else window.addEventListener('load', settle);
})();
